import { useCallback } from "react";
import DeleteButtonPopup from "/app/src/components/generic/components/buttons/DeleteButtonPopup";

/**
 * @param param id: number, refresh: () => void
 * @returns Delete Button JSX.Element
 */
export default function DeleteButtonCell({
  id,
  refresh,
  deleteFn,
  headerText,
  modalBody,
  onBeforeOpen,
}: {
  id: number;
  refresh: () => void;
  deleteFn: (id: number) => Promise<any>;
  headerText: string;
  modalBody?: React.ReactNode;
  onBeforeOpen?: () => void;
}) {
  const deleteRecord = useCallback(() => {
    return deleteFn(id);
  }, [deleteFn, id]);

  return (
    <DeleteButtonPopup
      headerText={headerText}
      modalBody={modalBody}
      deleteObjectFn={deleteRecord}
      refresh={refresh}
      onBeforeOpen={onBeforeOpen}
    />
  );
}
